import { GenericValue, DynamicContent, Language, HisUploadFile } from 'hisng';
import { Journal } from './journal';
import { GlobalIdentifier } from './global-identifier';
import { PublicationCreator } from './publication-creator';
import { Publisher } from './publisher';
import { Project } from '../../finance/model/project/project';
import { Conference } from './conference';
import { ResearchContract } from '../../common/model/finance/research-contract-classes';
import { PublicationChangeRequest } from './publication-change-request';
import { ResearchInfrastructure } from '../../research-infrastructure/model/research-infrastructure';
import { PublicationDocumentMetadata } from './publication-document-metadata';

export class Publication extends DynamicContent {
    // attributes #################################
    id: number;
    objGuid: string;

    title: string;
    subtitle: string;
    releaseYear: number;
    edition: string;
    volume: string;
    issue: string;
    pageRangeFrom: string;
    pageRangeTo: string;
    numberOfPages: number;
    articleNumber: string;
    series: string;
    numberInSeries: string;
    peerReviewedProcess: GenericValue;
    url: string;
    reference: string;
    blogName: string;
    embargoDate: Date;

    // to 1 relations #############################
    publicationType: GenericValue;

    status: GenericValue;
    documentType: GenericValue;
    publicationCreatorType: GenericValue;
    journal: Journal;
    conference: Conference;
    conferenceName: string;
    publisher: Publisher;
    parent: Publication;
    publicationResource: GenericValue;
    publicationResourceType: GenericValue;
    access: GenericValue;
    accessAfterEmbargoDate: GenericValue;
    license: GenericValue;
    qualificationThesis: GenericValue;
    visibilityValue: GenericValue;
    citations: string[][];

    // to many relations #########################
    globalIdentifiers: GlobalIdentifier[];
    researchAreas: GenericValue[];
    researchAreasKdsf: GenericValue[];
    subjectAreas: GenericValue[];
    languages: Language[];
    creators: PublicationCreator[];
    projects: Project[];
    fundingPrograms: ResearchContract[];
    researchInfrastructures: ResearchInfrastructure[];

    // keywords
    keyWords: GenericValue[];

    // listviews
    listviews: Record<string, any>;

    // abstract
    textAbstract: string;

    // attributes for intern only ############
    commentary: string;
    lockVersion: number;

    changeRequest: PublicationChangeRequest;

    publicationDocuments: PublicationDocumentMetadata[] = [];

    constructor(
        id?: number, publicationType?: GenericValue, title?: string, releaseYear?: number,
        status?: GenericValue, languages?: Language[]
    ) {
        super();
        this.id = id;
        this.publicationType = publicationType;
        this.title = title;
        this.releaseYear = releaseYear;
        this.status = status;
        this.languages = languages;
    }

    public static getDescription(p: Publication): string {
        let str = p.title + ' (' + p.releaseYear + ')';
        if ( p.globalIdentifiers?.length > 0 ) {
            str += ', ' + p.globalIdentifiers.map(gi => gi.globalIdentifierType.defaulttext + ': ' + gi.identifier).join(', ');
        }
        return str;
    }
}

export class SimplePublication {
    id: number;
    title: string;
}
